import React from "react";
import NotificationComponent from "../../components/NotificationComponent/NotificationComponent";

export default function NotificationPage() {
  return <NotificationComponent />;
}
